import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { BaseComponent } from "app/common/base/base.component";
import { Dialog } from "app/common/dialog";
import { NGXLogger } from "ngx-logger";

@Component({
    selector: "app-base-modal",
    template: "",
    standalone: false
})
export class BaseModalComponent extends BaseComponent implements OnInit {
  @ViewChild("modal") modal;
  @Input() size = "md";
  @Input() centered = false;
  @Input() blockModal = false;

  isModalOpen: boolean = false;

  modalOptions: NgbModalOptions;
  modalReference: NgbModalRef;

  constructor(
    public _translateService: TranslateService,
    protected dialog: Dialog,
    public title: Title,
    public logger: NGXLogger,
    public modalService: NgbModal
  ) {
    super(_translateService, title, dialog, logger);
  }

  ngOnInit(): void {
    this.modalOptions = {
      size: this.size,
      centered: this.centered,
    };
    this.setBlockModal();
  }

  setBlockModal() {
    if (this.blockModal) {
      this.modalOptions.backdrop = "static";
      this.modalOptions.keyboard = false;
    }
  }

  openModal(): void {
    this.modalReference = this.modalService.open(this.modal, this.modalOptions);
    this.isModalOpen = true;
    this.modalReference.result
      .then(() => {
        this.isModalOpen = false;
      })
      .catch((res) => {
        this.isModalOpen = false;
      });
  }
}
